import React, { useState } from 'react';
import DocsSidebar from './DocsSidebar';

const DocsLayout = ({ children, tocItems = [], activeTocItem = '' }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-[calc(100vh-64px)] -mx-3 sm:-mx-8 -my-4 sm:-my-8">
      {/* Left Sidebar */}
      <DocsSidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main Content */}
      <main className={`flex-1 min-w-0 overflow-x-hidden py-8 sm:py-12 px-4 sm:px-12 lg:px-16 max-w-4xl`}>
        {children}
      </main>

      {/* Right Sidebar - Table of Contents */}
      <aside className="hidden xl:block w-56 py-12 pr-6 sticky top-16 h-fit">
        <div className="text-[11px] font-semibold text-zinc-500 uppercase tracking-wider mb-4">
          On this page
        </div>
        <div className="flex flex-col gap-2 border-l border-dark-border pl-4">
          {tocItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`text-[13px] transition-colors ${
                activeTocItem === item.id
                  ? 'text-green-500'
                  : 'text-zinc-600 hover:text-zinc-400'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>
      </aside>
    </div>
  );
};

export default DocsLayout;
